export default __webpack_public_path__ + "static/media/IllustrationNotAdherent.7b4fb89a.png";